import React from 'react'
import styled, { keyframes } from 'styled-components'
import conditional, { whenProps } from 'tools/conditional'
import prop from 'tools/prop'
import { getToken as token } from 'theming'

const pulse = keyframes`
  50% {
    opacity: 0.2;
  }

  100% {
    opacity: 1;
  }
`

const Wrapper = styled.div`
  text-align: center;

  div:nth-child(1) {
    animation: ${pulse} 1s infinite ease-in-out -0.2s;
  }

  div:nth-child(2) {
    animation: ${pulse} 1s infinite ease-in-out -0.1s;
  }

  div:nth-child(3) {
    animation: ${pulse} 1s infinite ease-in-out 0s;
  }
`

interface DotProps {
  size?: number
  variant?: 'light' | 'dark'
}

const Dot = styled.div<DotProps>`
  display: inline-block;
  width: ${prop('size')}px;
  height: ${prop('size')}px;
  margin: ${token('space-2xs')};

  background-color: ${conditional({
    'color-neutral-white': whenProps({ variant: 'light' }),
    'color-neutral-dark': whenProps({ variant: 'dark' }),
  })};
  border-radius: ${token('border-radius-circle')};
`

export interface LoadingDotsProps {
  size?: number
  variant?: 'dark' | 'light'
}

export default function LoadingDots({
  size = 10,
  variant = 'dark',
  ...props
}: LoadingDotsProps): JSX.Element {
  return (
    <Wrapper role="progressbar" aria-label="Loading" {...props}>
      <Dot size={size} variant={variant} />
      <Dot size={size} variant={variant} />
      <Dot size={size} variant={variant} />
    </Wrapper>
  )
}
